module.exports = __webpack_public_path__ + "static/media/va.04b194d1.svg";